import script from "./GlobalDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalDialog.vue?vue&type=script&setup=true&lang=js"

import "./GlobalDialog.vue?vue&type=style&index=0&id=ceb6e16a&lang=css"

const __exports__ = script;

export default __exports__